export default __webpack_public_path__ + "static/media/jcb.8cbfc96e.svg";